import {Service} from "vue-typedi";
import {aromConnectorClient} from "@/configuration/api-client";
import {Customer} from "@/model/Customer";

@Service()
export class CustomerService {

    static CUSTOMERS_ENDPOINT: string = '/customers';

    public getCustomerData(orderNumber: string): Promise<Customer>  {
        const params = new URLSearchParams();
        params.append("orderNumber", orderNumber);

        return aromConnectorClient.get(CustomerService.CUSTOMERS_ENDPOINT, { params })
            .then((response: any) => {
                const data: Customer = response && response.data ? response.data : {};
                return Promise.resolve(data);
            }).catch(error => {
                return Promise.reject(error);
            });
    }
}